import React from 'react';

import Box from '@mui/material/Box';

import { useSidebarWidth } from '~components/hooks/useSidebarWidth';

interface Props {
  height?: string;
  width?: string | string[];
}

const Background = ({ height = '100vh' }: Props) => {
  const sidebarWidth = useSidebarWidth();
  return (
    <Box
      sx={{
        position: 'fixed',
        height,
        width: { xs: '100vw', sm: `calc(100vw - ${sidebarWidth}px)` },
        zIndex: '-1',
        opacity: 1,
        left: { xs: 0, sm: `${sidebarWidth}px` },
        background: 'url(/v2/backgrounds/blobs_bg.svg)',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {' '}
    </Box>
  );
};

export default Background;
